import React, { Component } from 'react';

export class HoverIconLink extends Component {
    constructor(props){
        super(props);
        this.state = {
            style: null,
            originalIconColor: this.props.style.color
        }
    }
    
    getStyle = () => {
        this.props.style.color = this.state.style;
        return this.props.style;
    }
    // style = props.style.cardButtonOption;

    onHover = () => {
        this.setState({
            style: this.props.hoverIconStyle
        })
    }

    onLeave = () => {
        this.setState({
            style: this.props.defaultIconStyle
        })
    }

    render = () => {
        return (
            <div onMouseOver={this.onHover()} onMouseOut={this.onLeave()}>
                <a href={this.props.href}>
                    <i  
                        style={this.getStyle()}
                        className={`fa fa-${this.props.icon}` || "fa fa-heart"}>
                    </i>
                </a>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// ./src/js/components/HoverIconLink.jsx